import { Table, Button } from "antd";
import { setOnViewDevice } from "Components/Report/reportSlice";
import { useChartParam, Parameter } from "Components/Report/OnDemand/charts/shared/utils";
import ChartCard from "Components/Report/OnDemand/charts/shared/ChartCard";
import { useAppDispatch, useAppSelector } from "store/hook";
import { signal_top } from "Utility/Types/report";
import { useReportTop } from "Components/Report/queries";
import type { ColumnsType } from "antd/lib/table";

const SignalTable = ({ param, id = "", isFetching }: { param: Parameter; id?: string; isFetching: boolean }) => {
  const disp = useAppDispatch();
  const { title } = useChartParam(param, id);
  const { filterForm } = useAppSelector((status) => status.report);
  const { loginCid, stateCid, level } = useAppSelector((status) => status.global);

  const { data: top } = useReportTop({
    filterForm,
    loginCid,
    stateCid,
    level,
    type: "signal_top",
  });
  const tableData = (top?.response?.[0]?.signal_top || []) as signal_top[];
  const columns: ColumnsType<signal_top> = [
    {
      title: "Location",
      dataIndex: "location",
      ellipsis: true,
      // responsive: ["xxl"],
    },
    {
      title: "Device",
      width: 170,
      render: (_, record) => (
        <Button type="link" onClick={() => disp(setOnViewDevice(record.id))}>
          {record.name !== "" ? record.name : record.id}
        </Button>
      ),
    },
    {
      title: "Model",
      dataIndex: "model",
      responsive: ["xxl"],
    },

    {
      title: "Poor",
      dataIndex: "poor",
      defaultSortOrder: "descend",
      sorter: {
        compare: (a, b) => a.poor - b.poor,
        multiple: 3,
      },
    },
    {
      title: "Fair",
      dataIndex: "fair",
      defaultSortOrder: "descend",
      sorter: {
        compare: (a, b) => a.fair - b.fair,
        multiple: 2,
      },
    },
    {
      title: "Good",
      dataIndex: "good",
      defaultSortOrder: "descend",
      sorter: {
        compare: (a, b) => a.good - b.good,
        multiple: 1,
      },
    },
    // {
    //   title: "Total",
    //   dataIndex: "total",
    //   render: (_: string, record: signal_top) => record.poor + record.fair + record.good,
    // },
  ];

  return (
    <ChartCard title={title} param={param} isFetching={isFetching}>
      {/* <AlarmDetail visible={visible} setVisible={setVisible} /> */}
      <Table
        columns={columns}
        dataSource={tableData}
        pagination={{ pageSize: 5, size: "small", showSizeChanger: false, showQuickJumper: true }}
        size="middle"
        rowKey={(record) => record.id}
      />
    </ChartCard>
  );
};

export default SignalTable;

// const AlarmDetail = ({ setVisible, visible }: { setVisible: (arg: boolean) => void; visible: boolean }) => {
//   return (
//     <>
//       <Drawer title="Device: XXX" placement="right" onClose={() => setVisible(false)} visible={visible} width={"90%"}>
//         <p>顯示單台Device的Charts</p>
//         <p>Health..</p>
//         <p>All in One...</p>
//       </Drawer>
//     </>
//   );
// };
